import React, { Component } from 'react'
import { APIURL } from '../../config/config'
import ProfileBySale from '../../components/Profile/ProfileBySale'
import CustomerFindCarBySale from '../../components/CustomerFindCar/CustomerFindCarBySale'
import CalendarList from '../../components/Calendar/CalendarList'
import axios from 'axios'
import { connect } from 'react-redux'

class DashboardSale extends Component {

  constructor (props) {
    super(props)
    this.state = {
      user: {}
    }
  }

  componentWillMount() {
    let user = JSON.parse(this.props.user)
    this.setState({user: user})
  }

  componentDidMount () {

  }

  loadCustomerDoc() {
    // customer_docs
    axios.get(APIURL+'/customer_doc')
      .then((res) => {
        //console.log('====loadCustomerDoc')
        //console.log(res.data)
        this.setState({customer_docs: res.data})
        //that.loadCarDocData()
      })
  }

  render () {

    return (
      <div className="animated fadeIn">

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
                {/*<div className="row">
                  <div className="col-md-6">
                    <h5>โปรไฟล์ลูกค้า</h5>
                  </div>
                  <div className="col-md-6">
                    <h5>ลูกค้าหารถ</h5>
                  </div>
                </div>*/}

                <div className="row">
                  <div className="col-md-6">
                    <ProfileBySale
                      saleId={this.state.user.user || ''}
                      sale={this.state.user || ''}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomerFindCarBySale
                      saleId={this.state.user.user || ''}
                      sale={this.state.user || ''}
                    />
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>

        {/*<div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
                <CalendarList />
              </div>
            </div>
          </div>
        </div>*/}

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})


/* class CustomBlinkingTxt extends Component {
  constructor(props) {
    super(props);
    this.state = { showText: true };
  }
  componentDidMount() {
    this.myInterval = setInterval(this.onBlinkText.bind(this),1200);
  }

  onBlinkText(){
    this.setState(previousState => {
      return { showText: !previousState.showText };
    });
  }

  render() {
    let display = this.state.showText ? this.props.text : '';
    return (
      <span className="badge badge-danger" style={{padding: 3}}>{display}</span>
    );
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }
} */


export default connect(mapStateToProps)(DashboardSale)
